module.exports = "//static.hsappstatic.net/collaboration-sidebar/static-1.48482/images/CommentIndicatorPointer.svg"